var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.472 7.928C8.15733 8.52 8 9.17333 8 9.888L10.288 9.888C10.288 9.30133 10.4427 8.82934 10.752 8.472C11.0613 8.11466 11.472 7.936 11.984 7.936C12.432 7.936 12.7893 8.056 13.056 8.296C13.3227 8.536 13.456 8.848 13.456 9.232C13.456 9.552 13.3707 9.83467 13.2 10.08C13.0293 10.3253 12.7573 10.5653 12.384 10.8C11.7973 11.1413 11.368 11.4827 11.096 11.824C10.824 12.1653 10.688 12.64 10.688 13.248V13.696H12.8V13.488C12.8 13.168 12.8987 12.8907 13.096 12.656C13.2933 12.4213 13.632 12.144 14.112 11.824C14.656 11.4507 15.0693 11.064 15.352 10.664C15.6347 10.264 15.776 9.71734 15.776 9.024C15.776 8.43733 15.6213 7.91467 15.312 7.456C15.0027 6.99733 14.5627 6.64 13.992 6.384C13.4213 6.128 12.7467 6 11.968 6C11.1467 6 10.4373 6.17333 9.84 6.52C9.24266 6.86667 8.78667 7.336 8.472 7.928Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.856 15.176C10.6053 15.416 10.48 15.7227 10.48 16.096C10.48 16.4693 10.608 16.7787 10.864 17.024C11.12 17.2693 11.4347 17.392 11.808 17.392C12.1813 17.392 12.496 17.2693 12.752 17.024C13.008 16.7787 13.136 16.4693 13.136 16.096C13.136 15.7227 13.0107 15.416 12.76 15.176C12.5093 14.936 12.192 14.816 11.808 14.816C11.424 14.816 11.1067 14.936 10.856 15.176Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpQuestionMark);
export default __webpack_public_path__ + "static/media/help-question-mark.94cc05cb0b357fe4c06a25f3ebb07a36.svg";
export { ForwardRef as ReactComponent };